// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".social-sharing__relative[data-v-476f14e7]{position:relative}", ""]);
// Exports
module.exports = exports;
